import { Component, Input } from '@angular/core';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { AaNgModule } from 'aa-ng';

@Component({
  selector: 'app-help-text-modal',
  imports: [AaNgModule],
  template: `
    <aa-dropdown
      class="link"
      [alignment]="alignment"
      [buttonClasses]="'icon-only link'"
      [buttonTitle]="modalTitle"
      [buttonRole]="'button'"
      [leftIcon]="{ definition: faQuestionCircle }"
      [openMenu]="showDropdown"
      (toggle)="resetShowDropdown()"
    >
      <button
        class="popup-close"
        [attr.aria-label]="'Close ' + modalTitle"
        (click)="forceClose()"
      >
        x
      </button>
      <ng-content></ng-content>
    </aa-dropdown>
  `,
  styleUrls: ['./help-text-modal.component.scss'],
})
export class HelpTextModalComponent {
  faQuestionCircle = faQuestionCircle;
  showDropdown: boolean = undefined;

  @Input() modalTitle: string;
  @Input() alignment: undefined | 'right';

  forceClose() {
    this.showDropdown = false;
  }

  resetShowDropdown() {
    this.showDropdown = undefined;
  }
}
